document.documentElement.classList.remove("no-js");

document.querySelectorAll("[data-mobile-menu]").forEach((menu) => {
  menu.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => menu.removeAttribute("open"));
  });
});

document.querySelectorAll("[data-product-form]").forEach((form) => {
  const selector = form.querySelector("[data-variant-select]");
  const price = form.closest("[data-product-root]")?.querySelector("[data-product-price]");
  const button = form.querySelector("[data-add-to-cart]");
  if (!selector || !button) return;

  selector.addEventListener("change", () => {
    const option = selector.selectedOptions[0];
    const available = option.dataset.available === "true";
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    button.disabled = !available;
    button.textContent = available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
  });
});

document.querySelectorAll("[data-cart-consent]").forEach((checkbox) => {
  const form = checkbox.closest("form");
  const checkout = form?.querySelector("[data-checkout-button]");
  if (!checkout) return;
  const sync = () => {
    checkout.disabled = !checkbox.checked;
  };
  checkbox.addEventListener("change", sync);
  sync();
});
